import { AppLanguageCode } from '@project-types/AppLanguageCodes';
import { LanguageDefinitions } from '@project-types/LanguageDefinitions';



export const APP_LANGUAGE_CODES = {
	CZ: 'CZ',
	SK: 'SK',
	DE: 'DE',
} as const;


export const LANGUAGE_DEFINITIONS: LanguageDefinitions = {
	CZ: {
		name: 'Čeština',
		locale: 'cs-CZ',
		isoLanguageCode: 'cs',
		currency: 'CZK',
		currencySymbol: 'Kč',
		dateFormat: 'DD.MM.YYYY',
		websiteDomain: 'vetlimce.cz',
	},
	SK: {
		name: 'Slovenčina',
		locale: 'sk-SK',
		isoLanguageCode: 'sk',
		currency: 'EUR',
		currencySymbol: '€',
		dateFormat: 'DD.MM.YYYY',
		websiteDomain: 'vetlimce.sk',
	},
	DE: {
		name: 'Deutsch',
		locale: 'de-DE',
		isoLanguageCode: 'de',
		currency: 'EUR',
		currencySymbol: '€',
		dateFormat: 'DD.MM.YYYY',
		websiteDomain: 'vetooo.de',
	},
} as const;


export const DEFAULT_LANGUAGE: AppLanguageCode = APP_LANGUAGE_CODES.DE;

export const SALES_NETWORK_LANGUAGES: AppLanguageCode[] | null = null;

export const FORM_SELECT_LANGUAGES: AppLanguageCode[] | null = [ APP_LANGUAGE_CODES.DE ];